import React, { useState, useEffect, useMemo } from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Cell,
  Text
} from "recharts";
import "react-awesome-lightbox/build/style.css";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";

import MultiSelect from "react-multi-select-component";
import Select from "react-select";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../../../styles/app/pages/CampaingPreview.scss";
export const Report2 = ({ props }) => {
  const _rows = props.rows.sort((a, b) => a.no - b.no);
  const [mainTask, setMainTask] = useState({});
  const [mainProduct, setMainProduct] = useState({});

  const pos_map = _rows.map((key) => key.pos);
  const pos_unique = [...new Set(pos_map)];
  const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
  const [pos_selected, pos_setSelected] = useState([]);

  const round_map = _rows.map((key) => key.round);
  const round_unique = [...new Set(round_map)];
  const round_options = round_unique.map((key) => ({ label: key, value: key }));
  const [round_selected, round_setSelected] = useState([]);

  const product_map = _rows.map((key) => key.product);
  const product_unique = [...new Set(product_map)];
  const product_options = product_unique.map((key) => ({
    label: key,
    value: key,
  }));

  const [agent_selected, agent_setSelected] = useState([]);

  const task_map = _rows.map((key) => key.task);
  const task_unique = [...new Set(task_map)];
  const task_options = task_unique.map((key) => ({ label: key, value: key }));
  const [task_types, tasktypes_setSelected] = useState([]);

  useEffect(() => {
    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
    pos_setSelected(pos_options);
    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({
      label: key,
      value: key,
    }));
    round_setSelected(round_options);
    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique.map((key) => ({
      label: key,
      value: key,
    }));
    const [default_product] = product_options;
    default_product && setMainProduct(default_product);
    const agent_map = _rows.map((key) => key.agent);
    const agent_unique = [...new Set(agent_map)];
    const agent_options = agent_unique.map((key) => ({
      label: key,
      value: key,
    }));
    agent_setSelected(agent_options);
    const task_map = props.tasks.map((key) => key.name);
    const tasks_types = [
      ...new Set(props.tasks.map((key) => key.input_type).flat()),
    ].reduce((hs, tp) => ({ ...hs, [tp]: true }), {});
    tasktypes_setSelected(tasks_types);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key, value: key }));
    const [default_task] = task_options;
    default_task && setMainTask(default_task);
  }, [_rows, props.tasks]);

  const raw = _rows
    .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    .filter((row) =>
      agent_selected.map((row) => row.value).includes(row.agent)
    );

  const data = {};
  for (const row of raw) {
    const key = data[row.pos] ?? {};
    const round = key[row.round] ?? {};
    const product = round[row.product] ?? {};
    const task = product[row.task] ?? {};
    if (task_types["File (photo)"]) {
      task.file = row.file;
      task.image = row.image;
    }
    if (task_types["Rate"]) {
      task.rate = row.rate;
    }
    if (task_types["Comment"]) {
      task.comment = row.comment;
    }
    if (task_types["Yes/No"]) {
      task.yesno = row.yesno;
    }
    if (task_types["Quantity"]) {
      task.quantity = row.quantity;
      task.sku = row.sku ?? 0;
    }
    task.manufacture = row.manufacture;

    product[row.task] = task;
    round[row.product] = product;
    key[row.round] = round;
    data[row.pos] = key;
  }

  const _data = [...raw]
    .sort((a, b) => a.round - b.round)
    .filter((row) =>
      row.product === mainProduct.value &&
      row.task === mainTask.value
    )
    .map((row) => ({
      ...row,
      round: "Round " + row.round,
      pos: row.pos,
      [row.pos]: row.quantity,
      quantity: row.quantity
    }))
  return (
    <Card.Body className="p-4 mt-5">
      <Container fluid>
        <Row className="w-100 justify-content-end"></Row>
        <br />
        <div className="card p-2 shadow-sm pb-5 px-4">
          <h4 className="text-muted">Filters Criteria</h4>
          <Row>
            <Col>
              <label>Select POS</label>
              <MultiSelect
                name="pos"
                options={pos_options}
                value={pos_selected}
                onChange={pos_setSelected}
                labelledBy={"Select POS"}
              />
            </Col>
            <Col>
              <label>Select Rounds</label>
              <MultiSelect
                name="round"
                options={round_options}
                value={round_selected}
                onChange={round_setSelected}
                labelledBy={"Select Round"}
              />
            </Col>
            <Col>
              <label>Select Products</label>
              <Select
                defaultValue={product_options[0]}
                options={product_options}
                onChange={setMainProduct}
              />
            </Col>
            <Col xs={3}>
              <label>Select Tasks</label>
              <Select
                defaultValue={task_options[0]}
                options={task_options}
                onChange={setMainTask}
              />
            </Col>
          </Row>
        </div>
        <br />

        <br />
        {!props.queryng ? (
          <>
            <span className="text-muted h4 mb-3">Task: </span><span className="h2"><strong>{mainTask.label}</strong></span>
            <Col xs={12}>
              <Card className="p-2 mb-2">
                <Card.Body>
                  <div className="row d-flex justify-content-between">

                    <h4 className="text-muted">Locations</h4>
                    <h4 className="text-muted">Quantity</h4>
                  </div>

                  <SimpleBarChart data={_data} xKey="pos" yKey="quantity" />

                </Card.Body>
              </Card>
            </Col>
            <Col className={12}>

            </Col>
          </>
        ) : (
          <div className="mt-2 w-100 d-flex justify-content-center">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}
      </Container>
    </Card.Body>
  );
};

const blues = [
  ["#457AA6"],
  ["#457AA6", "#E3EBF2"],
  ["#264F73", "#457AA6", "#E3EBF2"],
  ["#264F73", "#457AA6", "#A2BBD2", "#E3EBF2"],
  ["#1A334A", "#264F73", "#457AA6", "#A2BBD2", "#E3EBF2"]
];

const getColor = (length, index) => {
  if (length <= blues.length) {
    return blues[length - 1][index];
  }

  return blues[blues.length - 1][index % blues.length];
};

let count = 0

const YAxisLeftTick = ({ y, payload: { value } }) => {
  ++count
  const text = `#${count} ${value}`
  return (
    <Text x={0} y={y} textAnchor="start" verticalAnchor="middle" scaleToFit>
      {text}
    </Text>
  );
};

let ctx;

export const measureText14HelveticaNeue = text => {
  if (!ctx) {
    ctx = document.createElement("canvas").getContext("2d");
    ctx.font = "14px 'Helvetica Neue";
  }

  return ctx.measureText(text).width;
};

const BAR_AXIS_SPACE = 20;

const SimpleBarChart = ({ data, yKey, xKey }) => {
  const maxTextWidth = useMemo(
    () =>
      data.reduce((acc, cur) => {
        const value = cur[yKey];
        const width = measureText14HelveticaNeue(value.toLocaleString());
        if (width > acc) {
          return width;
        }
        return acc;
      }, 0),
    [data, yKey]
  );
  return (
    <ResponsiveContainer width={"100%"} height={50 * data.length} debounce={50}>
      <BarChart
        data={data}
        layout="vertical"
        margin={{ left: 190, right: maxTextWidth + (BAR_AXIS_SPACE - 8) }}
      >
        <XAxis hide axisLine={false} type="number" />
        <YAxis
          yAxisId={0}
          dataKey={xKey}
          type="category"
          axisLine={false}
          tickLine={false}
          tick={YAxisLeftTick}
        />
        <YAxis
          orientation="right"
          yAxisId={1}
          dataKey={yKey}
          type="category"
          axisLine={false}
          tickLine={false}
          tickFormatter={value => value.toLocaleString()}
          mirror
          tick={{
            transform: `translate(${maxTextWidth + BAR_AXIS_SPACE}, 0)`
          }}
        />
        <Bar dataKey={yKey} minPointSize={2} barSize={64}>
          {data.map((d, idx) => {
            return <Cell key={d[xKey]} fill={getColor(data.length, idx)} />;
          })}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};